import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRightIcon } from 'lucide-react';
interface CTAButtonProps {
  text: string;
  subtext?: string;
  href?: string;
  className?: string;
}
export function CTAButton({
  text,
  subtext,
  href,
  className = ''
}: CTAButtonProps) {
  const handleClick = (e: React.MouseEvent) => {
    if (!href) {
      e.preventDefault();
      document.getElementById('pricing')?.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  const ButtonContent = <motion.div whileHover={{
    scale: 1.02
  }} whileTap={{
    scale: 0.98
  }} animate={{
    scale: [1, 1.02, 1]
  }} transition={{
    duration: 2,
    repeat: Infinity,
    ease: 'easeInOut'
  }} className={`relative w-full group ${className}`} data-id="element-42">
      <div className="absolute -inset-1 bg-gradient-to-r from-red-600 to-orange-500 rounded-xl blur opacity-70 group-hover:opacity-100 transition duration-200" data-id="element-43"></div>
      <button onClick={handleClick} className="relative w-full flex flex-col items-center justify-center px-6 py-4 bg-gradient-to-b from-red-500 to-red-700 border-b-4 border-red-900 rounded-xl shadow-2xl text-white font-black text-xl md:text-2xl uppercase tracking-wide hover:from-red-400 hover:to-red-600 transition-all" data-id="element-44">
        <div className="flex items-center gap-2 text-center" data-id="element-45">
          {text}
          <ArrowRightIcon className="w-6 h-6 animate-bounce-x" data-id="element-46" />
        </div>
        {subtext && <span className="text-sm md:text-base font-medium text-red-100 mt-1 normal-case tracking-normal" data-id="element-47">
            {subtext}
          </span>}
      </button>
    </motion.div>;
  if (href) {
    return <a href={href} target="_blank" rel="noopener noreferrer" className="block w-full" data-id="element-48">
        {ButtonContent}
      </a>;
  }
  return ButtonContent;
}